import { Modal } from 'antd';
import { Dispatch, SetStateAction, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { ExportCartColumns } from '~/@core/infrastructure/api/services/gfpService';
import useGfpStore from '~/zustand/gfp/gfp-service-state';
import {
  CancelButton,
  CheckboxContainer,
  ExportButton,
  FooterContainer,
  ModalHeader,
  StyledCheckbox,
} from './ExportExcel.styled';

interface ModalExportExcelProps {
  isModalVisible: boolean;
  setIsModalVisible: Dispatch<SetStateAction<boolean>>;
}

const EXPORT_FIELDS: { key: keyof ExportCartColumns; label: string }[] = [
  { key: 'status', label: 'Status' },
  { key: 'car', label: 'Car' },
  { key: 'gfpNumber', label: 'N° GFP' },
  { key: 'cce', label: 'CC-e' },
  { key: 'type', label: 'Tipo' },
  { key: 'generationDate', label: 'Data Geração' },
  { key: 'deliveryDate', label: 'Data Entrega' },
  { key: 'commercialDate', label: 'Data Comercial' },
  { key: 'client', label: 'Cliente' },
  { key: 'product', label: 'Produto' },
  { key: 'productCode', label: 'Código produto' },
  { key: 'quality', label: 'Qualidade' },
  { key: 'packaging', label: 'Emb' },
  { key: 'packagingDescription', label: 'Descrição da embalagem' },
  { key: 'qeQpe', label: 'Qe x QpE' },
  { key: 'gfpObs', label: 'Obs GFP' },
  { key: 'multiGfp', label: 'Multi-GFP' },
  { key: 'printStatus', label: 'Status impressão' },
];

const getInitialColumns = (): Record<keyof ExportCartColumns, boolean> => {
  return EXPORT_FIELDS.reduce(
    (acc, field) => ({ ...acc, [field.key]: true }),
    {} as Record<keyof ExportCartColumns, boolean>,
  );
};

export default function ModalExportExcel({
  isModalVisible,
  setIsModalVisible,
}: ModalExportExcelProps) {
  const [columns, setColumns] = useState<Record<keyof ExportCartColumns, boolean>>(
    getInitialColumns(),
  );

  const { exportCart, isExporting } = useGfpStore(
    useShallow(state => ({
      exportCart: state.exportCart,
      isExporting: state.isExporting,
    })),
  );

  const onClose = () => {
    setIsModalVisible(false);
    setColumns(getInitialColumns());
  };

  const handleCheckboxChange = (key: keyof ExportCartColumns, checked: boolean) => {
    setColumns(prev => ({ ...prev, [key]: checked }));
  };

  const handleExport = async () => {
    await exportCart(columns as ExportCartColumns);
    onClose();
  };

  return (
    <Modal
      open={isModalVisible}
      onCancel={onClose}
      footer={null}
      closable={true}
      width={400}
      bodyStyle={{ padding: '20px 24px' }}
    >
      <ModalHeader>Exportar para Excel</ModalHeader>
      <CheckboxContainer>
        {EXPORT_FIELDS.map(field => (
          <StyledCheckbox
            key={field.key}
            checked={columns[field.key]}
            onChange={e => handleCheckboxChange(field.key, e.target.checked)}
          >
            {field.label}
          </StyledCheckbox>
        ))}
      </CheckboxContainer>
      <FooterContainer>
        <CancelButton onClick={onClose}>Cancelar</CancelButton>
        <ExportButton type="primary" onClick={handleExport} loading={isExporting}>
          Exportar arquivo
        </ExportButton>
      </FooterContainer>
    </Modal>
  );
}
